import React, { useEffect, useRef } from "react";
import { Circle, GoogleMap, LoadScript } from "@react-google-maps/api";

export default ({ lat, lng, radius }) => {
  const mapRef = useRef(null);

  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

  const containerStyle = {
    width: "100%",
    height: "350px",
  };
  const center = {
    lat,
    lng,
  };

  const adjustZoom = () => {
    if (mapRef.current) {
      const bounds = new window.google.maps.LatLngBounds();
      const adjustmentFactor = radius < 1000 ? 1.5 : 1.1;
      const latOffset = (radius * adjustmentFactor) / 111320;
      const lngOffset =
        (radius * adjustmentFactor) /
        (111320 * Math.cos((lat * Math.PI) / 180));

      bounds.extend({ lat: lat + latOffset, lng: lng + lngOffset });
      bounds.extend({ lat: lat - latOffset, lng: lng - lngOffset });

      mapRef.current.fitBounds(bounds);

      const listener = window.google.maps.event.addListener(
        mapRef.current,
        "idle",
        () => {
          const currentZoom = mapRef.current.getZoom();
          const minZoom = radius < 1000 ? 15 : currentZoom + 1;
          if (currentZoom > minZoom) {
            mapRef.current.setZoom(minZoom);
          }
          window.google.maps.event.removeListener(listener);
        },
      );
    }
  };

  const grayscaleStyle = [
    {
      elementType: "geometry",
      stylers: [{ color: "#f5f5f5" }],
    },
    {
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      elementType: "labels.text.stroke",
      stylers: [{ color: "#f5f5f5" }],
    },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [{ color: "#bdbdbd" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#ffffff" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#dadada" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#c9c9c9" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
  ];

  useEffect(() => {
    adjustZoom();
  }, [radius]);

  return (
    <LoadScript googleMapsApiKey={googleMapsApiKey}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={13}
        onLoad={(map) => {
          mapRef.current = map;
          adjustZoom();
        }}
        clickableIcons={false}
        options={{
          styles: grayscaleStyle,
          disableDefaultUI: true,
          scaleControl: false,
          zoomControl: false,
          gestureHandling: "none",
          fullscreenControl: false,
          keyboardShortcuts: false,
        }}
      >
        <>
          <Circle
            options={{
              fillColor: "#00abab",
              strokeWeight: 1,
              strokeOpacity: 1,
              fillOpacity: 0.1,
              strokeColor: "#00abab",
            }}
            radius={radius}
            center={{ lat, lng }}
          />
        </>
      </GoogleMap>
    </LoadScript>
  );
};
